import { useFormContext } from "react-hook-form";

import { CockroachDBSecretField } from "src/connections/config/database/cockroach/CockroachDBSecretField";
import { ConfigFieldsetCard as FieldsetCard } from "src/connections/config/FieldsetCard";
import { isFieldErrored } from "src/connections/config/isFieldErrored";
import {
  CockroachDBConnectionConfigInputs,
  Environment,
} from "src/connections/types";

type Props = {
  environment: Environment;
};

export const CockroachDBUsernamePasswordAuthFieldset: React.FC<Props> = ({
  environment,
}) => {
  const {
    formState: { errors },
  } = useFormContext<CockroachDBConnectionConfigInputs>();
  const envErrors =
    errors?.[`${environment}Config`]?.["usernamePasswordConfig"];

  return (
    <FieldsetCard className="last:mb-0">
      <CockroachDBSecretField
        environment={environment}
        helpText="The username used to connect to the database"
        isErrored={isFieldErrored(envErrors, "username")}
        secretConfigField="usernamePasswordConfig.username"
        secretName="Username"
        isRequired
      />
      <CockroachDBSecretField
        environment={environment}
        helpText="The password used to connect to the database"
        isErrored={isFieldErrored(envErrors, "password")}
        secretConfigField="usernamePasswordConfig.password"
        secretName="Password"
        isRequired
      />
    </FieldsetCard>
  );
};
